import { DATAFEED_API_HOSTNAME } from "../../../config/envConfig";
import magnifiAPIInstance from "./apiInstance";

export const datafeedAPIs = {
  getDataFeedMatches: (params) => {
    return magnifiAPIInstance.get(`${DATAFEED_API_HOSTNAME}/api/v2/datafeed/matches`, { params });
  },
  getDataFeedStatsPerformMetadata: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v1/datafeed/metadata`, data);
  },
  getDataFeedStatsPerformMatchId: ({ streamId }) => {
    return magnifiAPIInstance.get(`${DATAFEED_API_HOSTNAME}/api/v1/datafeed/statsPerform/${streamId}`);
  },
  getDataFeedStatsPerformPersons: ({ matchId }) => {
    return magnifiAPIInstance.get(`${DATAFEED_API_HOSTNAME}/api/v1/datafeed/statsPerform/persons/${matchId}`);
  },
  getDataFeedStatsPerformBallOutcome: ({ matchId }) => {
    return magnifiAPIInstance.get(
      `${DATAFEED_API_HOSTNAME}/api/v1/datafeed/statsPerform/filters/ball-outcome/${matchId}`,
    );
  },
  getStatsPerformPlayerAction: ({ matchId }) => {
    return magnifiAPIInstance.get(
      `${DATAFEED_API_HOSTNAME}/api/v1/datafeed/statsPerform/filters/player-action/${matchId}`,
    );
  },
  getDataFeedStatsPerformFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v1/datafeed/statsPerform/filters`, data);
  },
  getDataFeedStatsPerformSoccerFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v1/statsPerform/soccer/listQueries`, data);
  },
  getDataFeedStatsPerformBallIdForFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v1/datafeed/statsPerform/filters/ball-ids`, data);
  },
  getDataFeedStatsPerformEplMetadata: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/datafeed/metadata`, data);
  },
  getDataFeedCompetitions: ({ type, search = null }) => {
    return magnifiAPIInstance.get(`${DATAFEED_API_HOSTNAME}/api/v1/datafeed/competitions`, {
      params: {
        search,
        type,
        pageNo: 1,
        limit: 30,
      },
    });
  },
  getDataFeedSoccerTournaments: ({ competitionId, search = null }) => {
    return magnifiAPIInstance.get(`${DATAFEED_API_HOSTNAME}/api/v1/statsPerform/soccer/tournaments`, {
      params: {
        competitionId,
        search,
        pageNo: 1,
        limit: 30,
      },
    });
  },
  getDataFeedSoccerMatches: ({ tournamentId, search = null }) => {
    return magnifiAPIInstance.get(`${DATAFEED_API_HOSTNAME}/api/v1/statsPerform/soccer/matches`, {
      params: {
        tournamentId,
        search,
        pageNo: 1,
        limit: 40,
      },
    });
  },
  getDatafeedMatch: ({ matchId, provider, category }) => {
    return magnifiAPIInstance.get(`${DATAFEED_API_HOSTNAME}/api/v2/datafeed/matches/${matchId}`, {
      params: {
        provider,
        category,
      },
    });
  },
  getDataFeedVolleyStationFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/volleyStation/listQueries`, data);
  },
  getDataFeedSportradarHandballFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v1/sportRadar/handball/listQueries`, data);
  },
  getDataFeedSportMediaTennisFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/sportMedia/listQueries`, data);
  },
  getDataFeedVideoFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/datafeed/listVideoQueries`, data);
  },
  startDatafeedClipCuttingJob: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/datafeed/generate-clips`, data);
  },
  stopDatafeedClipCuttingJob: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/datafeed/stopQueueJob`, data);
  },
  getDataFeedNascarFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v1/nascarFeed/nascar/listQueries`, data);
  },
  getDataFeedOlympicIceHockeyFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/olympics/iceHockey/listQueries`, data);
  },
  getDataFeedOlympicCurlingFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/olympics/curling/listQueries`, data);
  },
  getDataFeedCBSAmericanFootballFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/cbs/americanFootball/listQueries`, data);
  },
  getDataFeedGraphicsData: ({ matchId, provider, category }) => {
    return magnifiAPIInstance.get(`${DATAFEED_API_HOSTNAME}/api/v2/datafeed/graphics/data/${matchId}`, {
      params: {
        provider,
        category,
      },
    });
  },
  getDatafeedOrganizationConfig: ({ entityId }) => {
    return magnifiAPIInstance.get(
      `${DATAFEED_API_HOSTNAME}/api/v2/datafeed/organization-config?organizationId=${entityId}`,
    );
  },
  getAllDatafeedConfigsForOrganization: ({ entityId }) => {
    return magnifiAPIInstance.get(
      `${DATAFEED_API_HOSTNAME}/api/v2/datafeed/all-datafeed-configs-for-organization?organizationId=${entityId}`,
    );
  },
  getDatafeedMappedMatch: ({ streamId }) => {
    return magnifiAPIInstance.get(`${DATAFEED_API_HOSTNAME}/api/v2/datafeed/datafeedMappedMatches/${streamId}`);
  },
  getDataFeedCBSBasketballFilters: (data) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/cbs/basketball/listQueries`, data);
  },
  createDatafeedConfig: (datafeedConfig) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v1/management/config`, datafeedConfig);
  },
  updateDatafeedConfig: ({ id, ...datafeedConfig }) => {
    return magnifiAPIInstance.patch(`${DATAFEED_API_HOSTNAME}/api/v1/management/config/${id}`, datafeedConfig);
  },
  updateDatafeedConfigDetails: ({ id, ...datafeedConfig }) => {
    return magnifiAPIInstance.patch(`${DATAFEED_API_HOSTNAME}/api/v1/management/config/${id}/details`, datafeedConfig);
  },
  getAllDatafeedConfigs: (payload) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v2/datafeed/all-datafeed-configs`, payload);
  },
  triggerDatafeedManualIngestion: ({ id }) => {
    return magnifiAPIInstance.post(`${DATAFEED_API_HOSTNAME}/api/v1/management/trigger-ingestion/${id}`);
  },
};
